import {useQuery} from '@tanstack/react-query'
import React, {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getCopierDetail} from '../../../apis/copier/copierDetail'

const useQueryCopierDetail = (id: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getCopiersDetail(id),
        queryFn: async () => {
            const {data} = await getCopierDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    useEffect(() => {
        refetch()
    }, [])

    return {data, refetch, isLoading}
}

export default useQueryCopierDetail
